import React from 'react';
import { InvoicingMethodControl } from 'src/components/enterprise/features/Corporate/components/Form/InvoicingMethodWrapper/InvoicingMethodControl/InvoicingMethodControl';
import { useInvoicingMethodWrapper } from 'src/components/enterprise/features/Corporate/components/Form/InvoicingMethodWrapper/hooks/useInvoicingMethodWrapper';

export function InvoicingMethodWrapper(): JSX.Element {
  const { singleOptionSelected, disabledMultiOption, multiDisableReason } =
    useInvoicingMethodWrapper();

  return (
    <InvoicingMethodControl
      name="invoicingMethod"
      id="invoicingMethod"
      singleOptionSelected={singleOptionSelected}
      disabledMultiOption={disabledMultiOption}
      multiDisableReason={multiDisableReason}
    />
  );
}
